import { render } from "./select-users.vue?vue&type=template&id=02055a3c&ts=true"
import script from "./select-users.vue?vue&type=script&lang=ts"
export * from "./select-users.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__